
export const buyBudgetReducer = (state = [], action) => {

    switch (action.type) {
        case '[BUYBUDGET] Load list':
            return {
                ...state,
                buyBudgets: action.payload
            }

        case '[BUYBUDGET] Set detail':
            return {
                ...state,
                detailBuyBudget: action.payload
            }

        default:
            return state
    }


}